import { DetailedHTMLProps, FC, HTMLProps } from 'react'
import { Link } from 'react-router-dom'
import BackIcon from '../icons/BackIcon'

type IProps = DetailedHTMLProps<HTMLProps<HTMLDivElement>, HTMLDivElement> & {
  path?: string
}

const BackButton: FC<IProps> = ({ path, ...props }) => {
  return path ? (
    <Link to={`${path}`}>
      <div
        className='text-gray-300 p-1 hover:bg-red-200 rounded-full hover:text-white duration-300 ease-in-out'
        {...props}
      >
        <BackIcon />
      </div>
    </Link>
  ) : (
    <div
      className='text-gray-300 p-1 hover:bg-red-200 rounded-full hover:text-white duration-300 ease-in-out cursor-pointer'
      {...props}
    >
      <BackIcon />
    </div>
  )
}

export default BackButton
